/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Empty_FilterInputs */

const en_us2_swap_empty_filter = /** @type {(inputs: Swap_Empty_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing matches this filter.`)
};

const pt_br2_swap_empty_filter = /** @type {(inputs: Swap_Empty_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada com esse filtro.`)
};

const es_419_swap_empty_filter = /** @type {(inputs: Swap_Empty_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada coincide con este filtro.`)
};

const pt_pt2_swap_empty_filter = /** @type {(inputs: Swap_Empty_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nada com esse filtro.`)
};

const fr_fr2_swap_empty_filter = /** @type {(inputs: Swap_Empty_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rien ne correspond à ce filtre.`)
};

const de_de2_swap_empty_filter = /** @type {(inputs: Swap_Empty_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts passt zu diesem Filter.`)
};

const it_it2_swap_empty_filter = /** @type {(inputs: Swap_Empty_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niente con questo filtro.`)
};

/**
* | output |
* | --- |
* | "Nothing matches this filter." |
*
* @param {Swap_Empty_FilterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_empty_filter = /** @type {((inputs?: Swap_Empty_FilterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Empty_FilterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_empty_filter(inputs)
	if (locale === "es-419") return es_419_swap_empty_filter(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_empty_filter(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_empty_filter(inputs)
	if (locale === "de-DE") return de_de2_swap_empty_filter(inputs)
	if (locale === "it-IT") return it_it2_swap_empty_filter(inputs)
	return en_us2_swap_empty_filter(inputs)
});
export { swap_empty_filter as "swap.empty_filter" }